module.exports = __webpack_public_path__ + "img/03_uk.d30e2b12.svg";